import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { PedidoExpedicao } from '../../types/estoque';
import { pedidosExpedicaoService } from '../../services';

const columns: ResourceColumn<PedidoExpedicao>[] = [
  { header: "Pedido", accessor: "numero_pedido_cliente" },
  { header: "Cliente", accessor: "cliente_nome" },
  { header: "Status", accessor: "status" },
  { header: "Data pedido", accessor: "data_pedido" },
  { header: "Quantidade total", accessor: "quantidade_total" }
];

export const PedidosExpedicaoListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Pedidos de expedição"
    description="Fila de pedidos e status."
    columns={columns}
    service={pedidosExpedicaoService}
    createPath="/admin/estoque/pedidos-expedicao/novo"
      onEdit={(item) => item.id && navigate("/admin/estoque/pedidos-expedicao/editar", { state: { record: item } })}
  />
  );
};